export default __webpack_public_path__ + "01ee1a08af5d78848d99a50d385d822a.png";